<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title style="background: #00a082;" class="text-h5 darken-3 white--text">
            Aprobar el proyecto seleccionado
          </v-card-title>
  
          <v-card-text>  
            <p class="text-center mt-4"> <b>{{ dato.aprobado_por_id?'Anular':'Aprobar' }}</b> proyecto seleccionado </p>
            <h5 class="text-center"> {{ dato.nombre_proyecto }} </h5>
            <p class="text-center"> Sede para aprobar: {{ dato.sede_portal_name }} </p>
            <p class="text-center purple--text">
              <b>La sede procederá a definir las fechas tentativas de campaña para este programa y, posteriormente, tu deberás aprobarlas.</b>
            </p>
            <v-progress-linear v-if="loading" class="mt-2" indeterminate/>
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="background: #00a082;" dark :disabled="loading" @click="enviar()"> confirmar </v-btn>
            <v-btn color="red" outlined @click="dialog = false"> Cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>
  
<script>
import { aprobar_seleccionado,desaprobar_seleccionado } from '@/views/oferta_academica/servicios/seleccionService.ts';

export default {
    data() {
        return {
            loading: false,
            dialog: false,
            dato: {},
            input: {}
        };
    },
    methods: {
        async openmodal(row) {
            // const sede = this.$store.state.CARGO.sede
            const user = this.$store.state.DATA_USER
            this.dato = row
            this.input = {
              seleccionado_id: row.id,
              aprobado_por_id: user.id
            }
            // window.console.log('>>>',row,sede,user);
            this.dialog = true
        },

        async enviar(){
            if(this.dato.aprobado_por_id){
              this.desaprobar()
            }else{
              this.aprobar();
            }
        },

        async aprobar(){
            this.loading = true
            const r = await aprobar_seleccionado(this.input)
            if(r && r.aprobar_seleccionado){ 
              this.$root.$notify.show('aprobado', { color: '#009800', x: 'left' });
              this.dialog = false
              this.dato.aprobado_por_id = r.aprobar_seleccionado.aprobado_por_id
              this.dato.fecha_aprobacion = r.aprobar_seleccionado.fecha_aprobacion
              this.dato.estado_aprobacion = r.aprobar_seleccionado.estado_aprobacion
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => {
                m += x.message
              });  
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(r);
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
              
            }
            
            this.loading = false
        },

        async desaprobar(){
            this.loading = true
            const desa = {
              seleccionado_id: this.input.seleccionado_id
            }
            const r = await desaprobar_seleccionado(desa)
            if(r && r.desaprobar_seleccionado){ 
              this.$root.$notify.show('desaprobado', { color: '#009800', x: 'left' });
              this.dialog = false
              this.dato.aprobado_por_id = r.desaprobar_seleccionado.aprobado_por_id
              this.dato.fecha_aprobacion = r.desaprobar_seleccionado.fecha_aprobacion
              this.dato.estado_aprobacion = r.desaprobar_seleccionado.estado_aprobacion
            }else if(r && r.graphQLErrors) {
              let m = ''
              r.graphQLErrors.forEach(x => {
                m += x.message
              });  
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
            }else{
              const m = JSON.stringify(r);
              this.$root.$notify.show(m, { color: '#980000', x: 'left' });
              
            }
            
            this.loading = false
        }
    }
};
</script>
  